
import React from 'react';
import Spinner from './Spinner';
import './_spinner.scss';
const FormSpinner = () => (
    <div className="form-spinner">
        <div style={{ margin: 'auto' }}>
            <Spinner />
        </div>
    </div>);
export default FormSpinner;

